gsap.set(".co-services-1-header", { opacity: 0 });
gsap.to(".co-services-1-header", {
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
gsap.set('.co-services-1-cell', { opacity: 0, y: 10 });
gsap.to('.co-services-1-cell', {
  opacity: 1,
  y: 0,
  duration: 0.75,
  stagger: 0.075,
  ease: "Power4.inOut"
});
// 1A
gsap.set('.co-services-1-a-header', { opacity: 0 });
gsap.to('.co-services-1-a-header', {
  scrollTrigger: {
    trigger: '.co-services-1-a',
    start: 'top 90%',
    end: 'bottom top'
  },
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
// 2
gsap.set('.co-services-2-frame', { y: 20, opacity: 0 });
gsap.to('.co-services-2-frame', {
  scrollTrigger: {
    trigger: '.co-services-2',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    y: 0,
    ease: "power2.inOut"
});
// scrub
// gsap.set('.co-services-2-content-image-wrapper', { top: "0%" });
// gsap.to('.co-services-2-content-image-wrapper', {
//   scrollTrigger: {
//     start: 'top bottom',
//     end: 'bottom top',
//     trigger: '.co-services-2',
//     scrub: true
//   },
//   top: "-10%"
// });
// 2
gsap.set('.co-services-3-header', { opacity: 0 });
gsap.to('.co-services-3-header', {
  scrollTrigger: {
    trigger: '.co-services-3',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    ease: "power2.inOut"
});
// 3
gsap.set('.co-services-3-left', { opacity: 0 });
gsap.to('.co-services-3-left', {
  scrollTrigger: {
    trigger: '.co-services-3-left',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    ease: "power2.inOut"
});
gsap.set('.co-services-3-right', { opacity: 0 });
gsap.to('.co-services-3-right', {
  scrollTrigger: {
    trigger: '.co-services-3-right',
    start: 'top 95%',
    end: 'bottom top'
  },
    duration: 1,
    opacity: 1,
    ease: "power2.inOut"
});
// scrub
gsap.set('.co-services-3-right img', { top: "0%" });
gsap.to('.co-services-3-right img', {
  scrollTrigger: {
    start: 'top bottom',
    end: 'bottom top',
    trigger: '.co-services-3-right',
    scrub: true
  },
  top: "-10%"
});